import { render, staticRenderFns } from "./ListJewelsPreview.vue?vue&type=template&id=cda5f7cc&scoped=true&"
import script from "./ListJewelsPreview.vue?vue&type=script&lang=js&"
export * from "./ListJewelsPreview.vue?vue&type=script&lang=js&"
import style0 from "./ListJewelsPreview.vue?vue&type=style&index=0&id=cda5f7cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda5f7cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2065084294/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cda5f7cc')) {
      api.createRecord('cda5f7cc', component.options)
    } else {
      api.reload('cda5f7cc', component.options)
    }
    module.hot.accept("./ListJewelsPreview.vue?vue&type=template&id=cda5f7cc&scoped=true&", function () {
      api.rerender('cda5f7cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ListJewelsPreview.vue"
export default component.exports